<form #zipcodeForm="ngForm" class="row">
	<mat-form-field class="col">
		<mat-label>{{ label }}</mat-label>
		<input matInput aria-label="Zipcode" type="text" [placeholder]="placeholder" [id]="id" [name]="name"
			[(ngModel)]="selectedZipcode.POSTAL_CODE" maxlength="5" pattern="^[0-9]{0,5}$" #searchString="ngModel"
			#searchStringInput [value]="selectedZipcode?.POSTAL_CODE" [required]="required"
			 [disabled]="disabled"  (input)="onZipcodeInput($event)" />
		<!--<button mat-icon-button matSuffix [attr.aria-label]="'Zipcode Valid'"
			[color]="selectedZipcode && selectedZipcode.ID ? 'primary' : 'warn'" tabindex="-1" [disabled]="disabled">
			<mat-icon mat-icon-button *ngIf="isLoading">
				<mat-spinner diameter="18"></mat-spinner>
			</mat-icon>
			<mat-icon mat-icon-button *ngIf="!isLoading && (zipcodeForm.dirty)">
			{{ selectedZipcode.ID ? "done" : "close" }}
		</mat-icon>
			<mat-icon mat-icon-button *ngIf="!isLoading && (zipcodeForm.dirty || selectedZipcode?.ID! > 0)">
				{{ selectedZipcode.ID ? "done" : "close" }}
			</mat-icon> 
 		</button>-->
	</mat-form-field>
	<app-msg *ngIf="!isLoading" class="msg-position"
		[msg]="{MSG:searchString.errors?.['idRequired'], SUCCESS:!searchString.errors?.['idRequired']}"></app-msg>

	
</form>